<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :center="true"
      title="服务号列表"
      :visible.sync="fwhVisible"
      width="700px"
      :before-close="closeEvent"
    >
      <div class="onrr">
        <el-radio-group v-model="serviceNo" >
          <el-radio :label="item.no"  :disabled="item.status==2" border v-for="item in fwhs"  class="fwhname" >{{item.name}}</el-radio>
        </el-radio-group>
      </div>
      <div class="btnitems">
        <el-button size="small" type="primary" @click="updateServiceNo">确认</el-button>
        <el-button size="small" @click="closeEvent">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getToken} from "../../../utils/auth";

  export default {
    name: "fwh",
    components: {
    },
    data() {
      return {
        serviceNo:'',
        fwhs:[],
      };
    },
    props: {
      fwhVisible: Boolean,
      orderId:String,
    },
     created() {
       this.getServiceNo()
    },

    methods: {
      //服务号
      async getServiceNo() {
        let res = await this.$get("/sw/getServiceNoList", {token: getToken()});
        this.fwhs = res.list
      },

      async updateServiceNo() {
        if (!this.serviceNo){
          this.$message.error("请选择服务号");
          return ;
        }
        let data = {
          id: this.orderId,
          serviceNo: this.serviceNo,
        }
        let res = await this.$post("/sw/updateServiceNo", data)
        if (res.code == 200) {
          this.$emit("successFwh");
        } else {
          this.$message.error(res.message);
        }
      },
      closeEvent() {
        this.$emit("closeFwh");
      },
    }
  };
</script>


<style lang="scss" scoped>
  .btnitems{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
  }
  .fwhname{
    width: 100px;
    margin-bottom: 20px;
  }
  .onrr{
   height: 500px;
    overflow: auto;
  }
  ::v-deep .el-radio {
    padding: 12px 20px 0 10px;
    margin-left: 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    height: 40px;
  }

</style>
